/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateSystemConfigurationCommand = {
    /**
     * Eshop multi localization
     */
    eshopMultiLocalizationEnabled?: boolean;
    /**
     * Card application enabled upload attachments.
     */
    cardApplicationFilesUploadEnabled?: boolean;
    /**
     * E-wallet on virtual card.
     */
    virtualCardEWalletEnabled?: boolean;
    /**
     * Eshop footer manual.
     */
    eshopFooterManualEnabled?: boolean;
    /**
     * SMTP permeability.
     */
    SMTPPermeabilityEnabled?: boolean;
    /**
     * Bank card as carrier.
     */
    bankCardAsCarrier?: boolean;
    /**
     * Haulier card as carrier.
     */
    haulierCardAsCarrier?: boolean;
    /**
     * Haulier card white list as carrier.
     */
    haulierCardWLAsCarrier?: boolean;
    /**
     * Virtual card as carrier.
     */
    virtualCardAsCarrier?: boolean;
    /**
     * Payment gateway.
     */
    paymentGateway?: string;
    /**
     * EET localization.
     */
    EETLocalization?: string;
    /**
     * Currency.
     */
    currency?: string;
    /**
     * Use camera to take customer photo in card application.
     */
    allowCameraInCardApplication?: boolean;
    /**
     * Allow card application for free.
     */
    allowFreeCardApplication?: boolean;
    /**
     * Allowed short term tickets.
     */
    allowShortTermTickets?: boolean;
    /**
     * Ticket min valid from.
     */
    ticketMinValidFrom?: string;
    /**
     * Show taxes on counter receipt.
     */
    showTaxOnReceipt?: boolean;
    /**
     * Region Code.
     */
    haulierTokenKey?: string;
    telshopMigration?: boolean;
    /**
     * Eshop payment types.
     */
    eshopAllowedPaymentTypes?: Array<'CASH' | 'BANK_CARD' | 'ELECTRONIC_WALLET' | 'INVOICE'>;
    /**
     * Counter payment types.
     */
    counterAllowedPaymentTypes?: Array<'CASH' | 'BANK_CARD' | 'ELECTRONIC_WALLET' | 'INVOICE'>;
    mapPhoneAllowedPaymentTypes?: Array<'CASH' | 'BANK_CARD' | 'ELECTRONIC_WALLET' | 'INVOICE'>;
    /**
     * Language code of the default locale.
     */
    defaultLanguage?: string;
    /**
     * Marketing consent on card.
     */
    marketingConsentCardEnabled?: boolean;
    /**
     * Refund reason on cancel ticket.
     */
    refundReasonEnabled?: boolean;
    showSimpleCardApplication?: boolean;
    addressStreetRequired?: boolean;
    addressStreetNumberRequired?: boolean;
    addressCityRequired?: boolean;
    addressZipCodeRequired?: boolean;
    ticketCancellationFinalizationEnabled?: boolean;
    priceListUseActualDateInsteadValidFrom?: boolean;
    eshopReclamationEnabled?: boolean;
    synchronizationWithExternalEnabled?: boolean;
    allowIsic?: boolean;
    assignCardWithoutAgeRestriction?: boolean;
    allowCustomerCardGroup?: boolean;
    allowPersistEshopSideMenu?: boolean;
    allowBankCardApplicationFromCounter?: boolean;
    allowCloseEshopToastOnlyUsingButton?: boolean;
    allowUpdateCardValidity?: boolean;
    allowFirstCardApplicationWithDiscountProfileForFree?: boolean;
    disableDeleteAccountWithActiveTicketsAndEP?: boolean;
    allowSetDefaultProfileValidFromByCardValidFrom?: boolean;
    allowCustomerRegistrationUnder15Years?: boolean;
    allowCustomerCreationUnder15Years?: boolean;
    allowCustomerProfileApplication?: boolean;
    allowGoogleLogin?: boolean;
    allowFacebookLogin?: boolean;
    allowTicketCancellation?: boolean;
    allowRewardProgram?: boolean;
    allowExpressCardProduction?: boolean;
    allowExternalCards?: boolean;
    allowWhitelists?: boolean;
    allowPickupInPostOffice?: boolean;
    allowReclamationCards?: boolean;
    allowPaperCards?: boolean;
    allowPersonalDetailsEdit?: boolean;
    allowPersonalDetailsOptional?: boolean;
    allowSmartCardWithoutStructure?: boolean;
    allowCouponAndCardValidToOverlap?: boolean;
    /**
     * Tariff core type.
     */
    tariffCoreType?: UpdateSystemConfigurationCommand.tariffCoreType;
    allowZoneCountPriceList?: boolean;
    allowClearing?: boolean;
    /**
     * Represent maximal number of customer profiles available for card application.
     */
    customerProfileLimit?: number;
    allowOffenses?: boolean;
    allowThirdPartyTickets?: boolean;
    /**
     * Filter data by tenant FTP username
     */
    tenantFTPName?: string;
    /**
     * Client current timezone offset in minutes. Is required.
     */
    timezoneOffset?: number;
};
export namespace UpdateSystemConfigurationCommand {
    /**
     * Tariff core type.
     */
    export enum tariffCoreType {
        ZONE = 'ZONE',
        RELATIONAL = 'RELATIONAL',
    }
}

